import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { OthersAction } from "../../store/actions";
import {
  Buttons,
  inputFields,
  upload,
  popover,
  university,
} from "../../components";

const EditVisaInfo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const id = location.pathname.split("/")[3];

  const { visaInfo } = useSelector((state) => state?.others);

  const [state, setState] = useState({
    countryName: null,
    countryID: null,
    countryPicture: null,
    visaDuration: null,
    costOfVisaApp: null,
    applicationCostOccurrence: null,
    medicalFees: null,
    feesCostOccurrence: null,
    visaProcessingTime: null,
    visaDescription: null,
    documentsRequired: [],
    pointsToNote: [],
    healthInsurance: { title: null, cost: null, description: null },
  });

  useEffect(() => {
    visaInfo?.map((visa) => {
      if (visa.id === parseInt(id)) {
        setState({
          countryName: visa?.name ?? null,
          countryID: visa?.id ?? null,
          countryPicture: visa?.visaInfos?.countryPicture ?? null,
          visaDuration: visa?.visaInfos?.visaDuration ?? null,
          costOfVisaApp: visa?.visaInfos?.costOfVisaApp ?? null,
          applicationCostOccurrence:
            visa?.visaInfos?.applicationCostOccurrence ?? null,
          medicalFees: visa?.visaInfos?.medicalFees ?? null,
          feesCostOccurrence: visa?.visaInfos?.feesCostOccurrence ?? null,
          visaProcessingTime: visa?.visaInfos?.visaProcessingTime ?? null,
          visaDescription: visa?.visaInfos?.visaDescription ?? null,
          documentsRequired: visa?.visaInfos?.documentsRequired
            ? visa?.visaInfos?.documentsRequired?.map((item) => item?.document)
            : [],
          pointsToNote: visa?.visaInfos?.pointsToNote
            ? visa?.visaInfos?.pointsToNote?.map((item) => item?.point)
            : [],
          healthInsurance: {
            title: visa?.visaInfos?.healthInsurance?.title,
            cost: visa?.visaInfos?.healthInsurance?.cost,
            description: visa?.visaInfos?.healthInsurance?.description,
          },
        });
      }
    });
  }, [id, visaInfo]);

  const handleSubmit = () => {
    const filteredDocs = state?.documentsRequired?.map((doc) => ({
      document: doc,
    }));
    const filteredPoints = state?.pointsToNote?.map((p) => ({ point: p }));

    const payload = {
      ...state,
      documentsRequired: filteredDocs,
      pointsToNote: filteredPoints,
    };

    dispatch(
      OthersAction.editVisaInfo(payload, (res) => {
        dispatch(OthersAction.getVisaInfo());
        if (res.status === 200) {
          navigate("/visa-information");
        }
      })
    );
  };

  return (
    <div className="text-black flex flex-col gap-5">
      <div className="grid grid-cols-2 gap-5">
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Country" required />
          <inputFields.DefaultInput value={state?.countryName} disabled />
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Country Picture" />
          <popover.WhitePopover
            content={
              <img src={state?.countryPicture} className="h-[5em] w-full" />
            }
            trigger="hover"
            placement="top"
          >
            <div>
              <upload.DefaultFileUpload
                onChange={(file) =>
                  setState({ ...state, countryPicture: file })
                }
                value={state.countryPicture}
                type="image"
              />
            </div>
          </popover.WhitePopover>
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Visa Duration" />
          <inputFields.DefaultInput
            onChange={(e) =>
              setState({ ...state, visaDuration: e.target.value })
            }
            value={state?.visaDuration}
          />
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Cost of Application" />
          <inputFields.DefaultInput
            onChange={(e) =>
              setState({ ...state, costOfVisaApp: e.target.value })
            }
            value={state?.costOfVisaApp}
          />
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Application Cost Occurrence" />
          <inputFields.DefaultInput
            onChange={(e) =>
              setState({ ...state, applicationCostOccurrence: e.target.value })
            }
            value={state?.applicationCostOccurrence}
          />
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Medical Fees" />
          <inputFields.DefaultInput
            onChange={(e) =>
              setState({ ...state, medicalFees: e.target.value })
            }
            value={state?.medicalFees}
          />
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Fees Cost Occurrence" />
          <inputFields.DefaultInput
            onChange={(e) =>
              setState({ ...state, feesCostOccurrence: e.target.value })
            }
            value={state?.feesCostOccurrence}
          />
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Visa Processing Time" />
          <inputFields.DefaultInput
            onChange={(e) =>
              setState({ ...state, visaProcessingTime: e.target.value })
            }
            value={state?.visaProcessingTime}
          />
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Visa Description" />
          <inputFields.DefaultTextbox
            onChange={(e) =>
              setState({ ...state, visaDescription: e.target.value })
            }
            value={state?.visaDescription}
          />
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <university.UniInputLabel title="Documents Required" />
        <inputFields.SelectDropdownTags
          onChange={(e) => setState({ ...state, documentsRequired: e })}
          value={state?.documentsRequired}
        />
      </div>
      <div className="flex flex-col gap-3">
        <university.UniInputLabel title="Points to Note" />
        <inputFields.SelectDropdownTags
          onChange={(e) => setState({ ...state, pointsToNote: e })}
          value={state?.pointsToNote}
        />
      </div>
      <div className="flex flex-col gap-3">
        <university.UniInputLabel title="Health Insurance" />
        <div className="grid grid-cols-2 gap-5">
          <div className="flex flex-col gap-3">
            <university.UniInputLabel title="Title" />
            <inputFields.DefaultInput
              onChange={(e) =>
                setState({
                  ...state,
                  healthInsurance: {
                    ...state?.healthInsurance,
                    title: e.target.value,
                  },
                })
              }
              value={state?.healthInsurance?.title}
            />
          </div>
          <div className="flex flex-col gap-3">
            <university.UniInputLabel title="Cost" />
            <inputFields.DefaultInput
              onChange={(e) =>
                setState({
                  ...state,
                  healthInsurance: {
                    ...state?.healthInsurance,
                    cost: e.target.value,
                  },
                })
              }
              value={state?.healthInsurance?.cost}
            />
          </div>
          <div className="flex flex-col gap-3 col-span-2">
            <university.UniInputLabel title="Description" />
            <inputFields.DefaultTextbox
              onChange={(e) =>
                setState({
                  ...state,
                  healthInsurance: {
                    ...state?.healthInsurance,
                    description: e.target.value,
                  },
                })
              }
              value={state?.healthInsurance?.description}
            />
          </div>
        </div>
      </div>
      <div className="flex w-full justify-end">
        <Buttons.DefaultButton onClick={handleSubmit}>
          Submit
        </Buttons.DefaultButton>
      </div>
    </div>
  );
};

export default EditVisaInfo;
